import { environment } from '../environments/environment';

export const buildLegacyUrl = (
  smId: string,
  startDate: string,
  endDate: string,
  modelId?: string,
) =>
  `${environment.legacyUrl}/update-sm-ga?superModel=${smId}&world_date_from=${startDate}&world_date_to=${endDate}${modelId ? `&model=${modelId}` : ''}&fromPersonalOffer=true`;
